import React from 'react';
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Stack,
  Button,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GroupsIcon from '@mui/icons-material/Groups';

// Teal palette — match app Sidebar / Subscription
const teal = { 50: '#f0fdfa', 100: '#ccfbf1', 600: '#0d9488', 700: '#0f766e', 800: '#115e59' };

const TeamLimitAlertModal = ({ open, onClose, onAddUserSlot, maxAllowed, currentPlan }) => {
  const isReady = typeof maxAllowed === 'number' && maxAllowed > 0;

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-title" aria-describedby="modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 400 },
          maxWidth: '95vw',
          bgcolor: '#fff',
          borderRadius: 2,
          boxShadow: '0 24px 48px rgba(0,0,0,0.12)',
          border: '1px solid',
          borderColor: 'rgba(0,0,0,0.08)',
          p: 3,
          outline: 0,
        }}
      >
        <IconButton
          aria-label="Close"
          onClick={onClose}
          size="small"
          sx={{
            position: 'absolute',
            right: 12,
            top: 12,
            color: 'grey.600',
            '&:hover': { bgcolor: 'grey.100' },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            bgcolor: teal[50],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
          }}
        >
          <GroupsIcon sx={{ fontSize: 28, color: teal[700] }} />
        </Box>

        <Typography
          id="modal-title"
          variant="h6"
          component="h2"
          textAlign="center"
          sx={{
            mb: 1.5,
            fontWeight: 700,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            color: 'grey.900',
            fontSize: '1.25rem',
          }}
        >
          Team limit reached
        </Typography>

        {isReady ? (
          <>
            <Typography
              id="modal-description"
              textAlign="center"
              sx={{
                mb: 3,
                fontSize: '0.9375rem',
                lineHeight: 1.6,
                color: 'grey.600',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
              }}
            >
              Your plan includes up to <strong style={{ color: teal[800] }}>{maxAllowed}</strong> team{' '}
              {maxAllowed === 1 ? '' : 's'}. To create more teams, upgrade your subscription or add more team
              slots from Settings.
            </Typography>
            <Stack direction="row" justifyContent="center">
              <Button
                onClick={onClose}
                variant="outlined"
                sx={{
                  px: 2.5,
                  py: 1.25,
                  textTransform: 'none',
                  fontWeight: 600,
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  borderColor: 'grey.300',
                  color: 'grey.700',
                  '&:hover': { borderColor: 'grey.400', bgcolor: 'grey.50' },
                }}
              >
                Close
              </Button>
            </Stack>
          </>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
            <CircularProgress size={32} sx={{ color: teal[600] }} />
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default TeamLimitAlertModal;
